<script setup lang="ts">
import { useAsyncState } from '@vueuse/core'
import axios from 'axios'

const router = useRouter()
const route = useRoute()
const oldId = computed(() => route.params.oldNewsId)

const { state, isReady } = useAsyncState(
  axios.get(`//${import.meta.env.VITE_APP_CDN_HOST}/maplestory/temp/newsIDMapping`).then(({ data }) => data),
  [] as { id: number; oldID: number; category: string }[]
)

watchEffect(() => {
  if (isReady.value && oldId.value) {
    const found = state.value.find((one: any) => one.oldID == oldId.value)
    if (!found) router.replace({ name: 'news-list', params: { newsType: 'all' } })
    else {
      router.replace({
        name: 'news-detail',
        params: { newsType: found.category, newsId: found.id, seo: route.params.seo },
      })
    }
  }
})
</script>
<template>
  <div>
    <Loading class="body" :show="true" />
  </div>
</template>
<style lang="scss" scoped>
.body {
  min-height: 30vh;
}
</style>
